import script from "./goRinSyo0056.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0056.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0056.vue?vue&type=style&index=0&id=0aa07e3b&lang=scss"

const __exports__ = script;

export default __exports__